import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm13 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1 10H5l4-4 2 2 3-3z",
      clipRule: "evenodd"
    }
  )
);
var SvgImageFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ImageFilled_default = SvgImageFilled;

export { ImageFilled_default as default };
